import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { DeleteGroupAdapter } from '../adapter/deleteGroupAdapter';

/**
 * グループを削除するUseCase
 */
export class DeleteGroupUseCase {
  /**
   * グループを削除する モック関数
   * @param repository - リポジトリ
   * @param groupId - グループID
   */
  public ExecuteMock = async (repository: IGroupRepository, groupId: string): Promise<INetworkResult<void, Error>> => {
    try {
      const request = DeleteGroupAdapter.adaptForRequest(groupId);
      const result = await repository.deleteGroup(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
